import Provider from './src/provider';

export const shouldUpdateScroll = () => {
    window.scrollTo(0, 0);
    return false;
};
export const wrapRootElement = Provider;
